<template>
  <div style="margin-top: 60px">
    <div
      style="display: flex; justify-content: space-between; align-items: center"
    >
      <div>
        <h1 style="font-size: large; font-weight: 700">Order and Invoices</h1>
        <p style="color: #6b7280; font-size: 14px">
          View and manage seller's orders and invoices
        </p>
      </div>

      <div style="display: flex; align-items: center; gap: 16px">
        <a-button
          :loading="exportLoading"
          @click="exportExcell"
          style="border-radius: 6px; background: #f9fafb; color: #374151"
          icon="download"
        >
          Export
        </a-button>
      </div>
    </div>

    <div>
      <a-row
        type="flex"
        align="top"
        :gutter="[16, 16]"
        style="margin-top: 30px"
      >
        <a-col :span="6">
          <div
            style="
              background: #fff;
              border-radius: 6px;
              padding: 20px;
              border: 1px solid #e6e6e6;
            "
          >
            <a-statistic
              :value-style="{
                color: '#05004E',
                fontSize: '16px',
                fontWeight: 'bold',
              }"
              :title-style="{ fontSize: '16px' }"
              :value="orderStats.totalOrders"
            >
              <template #title>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <span>Total Orders</span>
                  <i
                    class="fa fa-briefcase"
                    aria-hidden="true"
                    style="color: #2563eb"
                  ></i>
                </div>
              </template>
            </a-statistic>
          </div>
        </a-col>

        <a-col :span="6">
          <div
            style="
              background: #fff;
              border-radius: 6px;
              padding: 20px;
              border: 1px solid #e6e6e6;
            "
          >
            <a-statistic
              :value-style="{
                color: '#05004E',
                fontSize: '16px',
                fontWeight: 'bold',
              }"
              :title-style="{ fontSize: '16px' }"
              :value="formatAmount(orderStats.totalInvoiceValue)"
            >
              <template #title>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    justify-content: space-between;
                  "
                >
                  <span>Total Invoice Value</span>
                  <i
                    class="fa fa-credit-card"
                    aria-hidden="true"
                    style="color: #000; font-size: 14px"
                  ></i>
                </div>
              </template>
            </a-statistic>
          </div>
        </a-col>

        <a-col :span="6">
          <div
            style="
              background: #fff;
              border-radius: 6px;
              padding: 20px;
              border: 1px solid #e6e6e6;
            "
          >
            <a-statistic
              :value-style="{
                color: '#05004E',
                fontSize: '16px',
                fontWeight: 'bold',
              }"
              :title-style="{ fontSize: '16px' }"
              :value="orderStats.invoicesPaid"
            >
              <template #title>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    justify-content: space-between;
                  "
                >
                  <span>Invoices Paid</span>
                  <i
                    class="fa fa-money-bill"
                    aria-hidden="true"
                    style="color: #059669; font-size: 14px"
                  ></i>
                </div>
              </template>
            </a-statistic>
          </div>
        </a-col>
        <a-col :span="6">
          <div
            style="
              background: #fff;
              border-radius: 6px;
              padding: 20px;
              border: 1px solid #e6e6e6;
            "
          >
            <a-statistic
              :value-style="{
                color: '#05004E',
                fontSize: '16px',
                fontWeight: 'bold',
              }"
              :title-style="{ fontSize: '16px' }"
              :value="formatAmount(orderStats.creditSales)"
            >
              <template #title>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    justify-content: space-between;
                  "
                >
                  <span>Credit Sales</span>
                  <i
                    class="fa fa-exclamation-circle"
                    aria-hidden="true"
                    style="color: #ef4444; font-size: 14px"
                  ></i>
                </div>
              </template>
            </a-statistic>
          </div>
        </a-col>
      </a-row>
    </div>

    <div style="margin-top: 30px">
      <!-- Search + Filters -->
      <a-row :gutter="16" style="margin-bottom: 16px">
        <a-col :span="6">
          <a-label>Search by Order</a-label>
          <a-input
            v-model="search"
            placeholder="Search by Order ID"
            allowClear
          />
        </a-col>

        <a-col :span="6">
          <a-label>Search by Order Status</a-label>
          <a-select
            v-model="filters.status"
            placeholder="Filter by Order Status"
            allowClear
            style="width: 100%"
          >
            <a-select-option
              v-for="val in orderStatusFilters"
              :key="val.value"
              :value="val.value"
            >
              {{ val.label }}
            </a-select-option>
          </a-select>
        </a-col>

        <a-col :span="6">
          <a-label>Search by Warehouse</a-label>
          <a-select
            v-model="filters.warehouse"
            placeholder="Filter by Warehouse"
            allowClear
            style="width: 100%"
          >
            <a-select-option
              v-for="warehouse in warehouseOptions"
              :key="warehouse"
              :value="warehouse"
            >
              {{ warehouse }}
            </a-select-option>
          </a-select>
        </a-col>

        <a-col :span="6">
          <a-label>Search by Fulfillment Type</a-label>
          <a-select
            v-model="filters.fulfilmentType"
            placeholder="Filter by Fulfillment Type"
            allowClear
            style="width: 100%"
          >
            <a-select-option
              v-for="item in FulfilmentTypeFilters"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>

      <!-- Orders Table -->
      <a-table
        :columns="columns"
        :data-source="orders"
        row-key="id"
        :pagination="tablePagination"
        :scroll="{ x: 'max-content' }"
        :loading="loading"
        @change="handleTableChange"
      >
        <template slot="actions" slot-scope="text, record">
          <a-button
            type="link"
            icon="eye"
            style="cursor: pointer; color: #26a246"
            @click="() => viewOrder(record)"
          />
          <!-- <a-button
            v-if="record.status !== 5"
            type="link"
            icon="check"
            style="cursor: pointer; color: #26a246"
            @click="() => viewOrder(record)"
          /> -->
        </template>
      </a-table>

      <a-modal
        v-model="viewModalVisible"
        title="View Order Details"
        width="800px"
        :footer="null"
        @cancel="viewModalVisible = false"
      >
        <h3>View Details</h3>
      </a-modal>
    </div>
  </div>
</template>
<script>
import moment from "moment";

import sellersService from "../../../api/sellers.service";
import * as XLSX from "xlsx";
import {
  formatAmount,
  formatDate,
  FulfilmentTypeFilters,
  invoiceStatus,
  orderStatus,
  orderStatusFilters,
} from "../../../utils";
import StatusTag from "../../shared-components/StatusTag.vue";

export default {
  name: "OrderAndInvoices",
  // eslint-disable-next-line vue/no-unused-components
  components: { StatusTag },
  props: {
    sellerId: {
      type: String,
      required: true,
      default: "",
    },
  },
  data() {
    return {
      viewModalVisible: false,
      loading: false,
      search: "",
      filters: {
        status: undefined,
        warehouse: undefined,
        fulfilmentType: undefined,
      },
      pagination: {
        pageIndex: 1,
        pageSize: 10,
        totalCount: 0,
      },
      FulfilmentTypeFilters,
      orderStatusFilters,
      searchDebounceTimeout: null,
      warehouseOptions: [],
      orders: [],
      orderDetails: {},
      columns: [
        { title: "Order #", dataIndex: "id", key: "id" },
        {
          title: "Invoice #",
          dataIndex: "invoiceResponse.id",
          key: "invoiceId",
        },
        {
          title: "Purchase Date",
          dataIndex: "createdAt",
          key: "createdAt",
          customRender: (record) => formatDate(record),
        },
        {
          title: "Due Date",
          dataIndex: "invoiceResponse.dueDate",
          key: "dueDate",
          customRender: (record) => formatDate(record),
        },
        {
          title: "Amount",
          dataIndex: "invoiceResponse.discountedValue",
          key: "amount",
          customRender: (record) => formatAmount(record),
        },
        {
          title: "Customer",
          dataIndex: "invoiceResponse.customerBusinessName",
          key: "customerBusinessName",
          customRender: (record) => record || "N/A",
        },
        {
          title: "Warehouse",
          dataIndex: "warehouseName",
          key: "warehouseName",
          customRender: (record) => record || "N/A",
        },
        {
          title: "Fulfillment",
          dataIndex: "fulfilmentType",
          key: "fulfilmentType",
        },
        {
          title: "Channel",
          dataIndex: "channel",
          key: "channel",
          customRender: (text) => text || "N/A",
        },
        {
          title: "Invoice Status",
          dataIndex: "invoiceResponse.status",
          key: "invoiceStatus",
          customRender: (record) => {
            return this.$createElement("StatusTag", {
              props: { status: invoiceStatus[record] },
            });
          },
        },
        {
          title: "Order Status",
          dataIndex: "status",
          customRender: (record) => {
            return this.$createElement("StatusTag", {
              props: { status: orderStatus[record] },
            });
          },
        },
        {
          title: "Actions",
          key: "actions",
          scopedSlots: { customRender: "actions" },
        },
      ],
      invoices: [],
      orderStats: {
        totalOrders: 0,
        totalInvoiceValue: 0,
        invoicesPaid: 0,
        creditSales: 0,
      },
      exportLoading: false,
    };
  },
  computed: {
    tablePagination() {
      return {
        current: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize,
        total: this.pagination.totalCount,
        showTotal: (total, range) =>
          `${range[0]}-${range[1]} of ${total} orders`,
        showSizeChanger: false,
      };
    },
  },
  watch: {
    sellerId: {
      immediate: true,
      handler(newVal) {
        console.log("sellerId changed:", newVal);
        if (newVal) {
          this.pagination.pageIndex = 1;
          this.fetchOrders();
          this.fetchWarehouses();
        }
      },
    },

    search() {
      if (this.searchDebounceTimeout) clearTimeout(this.searchDebounceTimeout);
      this.searchDebounceTimeout = setTimeout(() => {
        this.pagination.pageIndex = 1;
        this.fetchOrders();
      }, 400);
    },
    filters: {
      handler() {
        this.pagination.pageIndex = 1;
        this.fetchOrders();
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchOrders();
  },
  methods: {
    async fetchOrders() {
      if (!this.sellerId) return;
      this.loading = true;
      const params = {
        search: this.search,
        status: this.filters.status,
        warehouse: this.filters.warehouse,
        fulfilmentType: this.filters.fulfilmentType,
        pageIndex: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize,
      };
      const ordersResponse = await sellersService.getSellerOrders(
        this.sellerId,
        params
      );

      if (ordersResponse.status === 200) {
        this.orders  = ordersResponse.data.data.results;
        this.pagination.totalCount = ordersResponse.totalCount || 0;
        this.pagination.pageIndex = ordersResponse.pageIndex || 1;
        } else {
        this.orders = [];
        this.orderStats = {
          totalOrders: 0,
          totalInvoiceValue: 0,
          invoicesPaid: 0,
          creditSales: 0,
        };
        this.$message.error("Failed to fetch orders");
      }
      this.loading = false;
    },
    async fetchWarehouses() {
      if (!this.sellerId) return;
      const response = await sellersService.fetchSellerDistributionCenters(this.sellerId);
      if (response && response.status === 200 && response.data && response.data.data && response.data.data.results) {
        this.warehouseOptions = response.data.data.results.map(w => w.name);
      } else {
        this.warehouseOptions = [];
      }
    },
    handleTableChange(pagination) {
      if (pagination.current !== this.pagination.pageIndex) {
        this.pagination.pageIndex = pagination.current;
        this.fetchOrders();
      }
    },
    viewOrder(record) {
      if (!record) return;
      const orderId = record.id || record.orderId;
      if (parseInt(record.status) === 1) {
        this.$router.push({ name: 'FulfillOrder', params: { userId: this.sellerId, orderId } });
      } else {
        this.$router.push({ name: 'seller-order-details', params: { userId: this.sellerId, orderId } });
      }
    },

    async exportExcell() {
      try {
        this.exportLoading = true;

        // Prepare the data for export
        const exportData = this.orders.map((order) => ({
          "Order ID": order.id,
          "Invoice ID": order.invoiceResponse?.id || "N/A",
          "Purchase Date": moment(order.createdAt).format("YYYY-MM-DD"),
          Warehouse: order.warehouseName || "N/A",
          "Invoice Status": this.getInvoiceStatusText(order.invoiceResponse?.status),
          "Due Date": order.invoiceResponse?.dueDate
            ? moment(order.invoiceResponse.dueDate).format("YYYY-MM-DD")
            : "N/A",
          Customer: order.invoiceResponse?.customerBusinessName || "N/A",
          "Fulfillment Type": order.fulfilmentType || "N/A",
          Channel: order.channel || "N/A",
          "Order Status": this.getOrderStatus(order.status),
          "Total Value": order.invoiceResponse?.discountedValue
            ? formatAmount(order.invoiceResponse.discountedValue)
            : "N/A",
          "Payment Terms": order.invoiceResponse?.customerPaymentTerms
            ? `${order.invoiceResponse.customerPaymentTerms} days`
            : "N/A",
          "Business Type": order.invoiceResponse?.customerBusinessType || "N/A",
          Address: order.invoiceResponse?.customerAddress || "N/A",
          City: order.invoiceResponse?.customerCity || "N/A",
          Country: order.invoiceResponse?.customerCountry || "N/A",
        }));

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(exportData);

        // Set column widths
        const columnWidths = [
          { wch: 10 }, // Order ID
          { wch: 12 }, // Invoice ID
          { wch: 12 }, // Purchase Date
          { wch: 15 }, // Warehouse
          { wch: 15 }, // Invoice Status
          { wch: 12 }, // Due Date
          { wch: 20 }, // Customer
          { wch: 15 }, // Fulfillment Type
          { wch: 10 }, // Channel
          { wch: 20 }, // Order Status
          { wch: 15 }, // Total Value
          { wch: 15 }, // Payment Terms
          { wch: 15 }, // Business Type
          { wch: 30 }, // Address
          { wch: 15 }, // City
          { wch: 15 }, // Country
        ];
        worksheet["!cols"] = columnWidths;

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

        // Generate filename with current date
        const fileName = `Orders_Export_${moment().format(
          "YYYY-MM-DD_HH-mm"
        )}.xlsx`;

        // Save the file
        XLSX.writeFile(workbook, fileName);

        this.$message.success("Orders exported successfully!");
      } catch (error) {
        console.error("Error exporting orders:", error);
        this.$message.error("Failed to export orders. Please try again.");
      } finally {
        this.exportLoading = false;
      }
    },
    getInvoiceStatusText(status) {
      if (status === undefined || status === null) return "N/A";
      const statusMap = {
        0: "Pending",
        1: "Partially Paid",
        2: "Paid",
        3: "Overdue",
        4: "Critically Overdue",
        5: "Cancelled",
      };
      return statusMap[status] || "Unknown";
    },
    getOrderStatus(status) {
      const statusMap = {
        0: "New",
        1: "Awaiting Fulfillment",
        2: "Fulfilling",
        3: "Complete",
        4: "Canceled",
        5: "Received",
      };
      return statusMap[status] || "Unknown";
    },
    formatDate,
    formatAmount,
  },
};
</script>
<style scoped></style>
